import { Query, QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { CartsState, CartsStore } from 'projects/cart-tv/src/app/data/carts.store';


@Injectable({
  providedIn: 'root'
})
export class CartsQuery extends QueryEntity<CartsState> {
  lastScan$ = this.select(state => state.ui.lastScan);
  deletedCart$ = this.select(state => state.ui.deletedCart);

  constructor(protected store: CartsStore) {
    super(store);
  }
}
